<template>
  <main class="register">
    <section class="section">
      <Breadcrumb step="1"></Breadcrumb>
    </section>

    <section class="wrapper section">
      <FormRegister></FormRegister>
    </section>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import FormRegister from '@/components/forms/FormRegister.vue';

export default {
  name: 'register',
  components: {
    Breadcrumb,
    FormRegister
  },
  mounted() {
    if (process.env.VUE_APP_ENV === 'production') {
      window.fbq('track', 'PageView');
    }
  }
};
</script>
